import { apiClient } from './client';
import type {
  DlqStats,
  DlqMessageResponse,
  ReprocessRequest,
  ReprocessResponse,
  ReprocessAllRequest,
  ReprocessAllResponse,
  ReprocessJobStatus,
  DeleteRequest,
  DeleteResponse,
  PurgeRequest,
  PurgeResponse,
  QueueName,
  DlqAuditListResponse,
  DlqAuditStatsResponse,
  DlqAuditListParams,
  BatchUpdateDlqAuditRequest,
} from '@/types/dlq';

export async function getDlqStats(): Promise<DlqStats> {
  return apiClient.get('/api/dlq/stats');
}

export async function getDlqMessages(
  queue: QueueName,
  limit: number = 10,
): Promise<DlqMessageResponse> {
  return apiClient.get(`/api/dlq/messages?queue=${queue}&limit=${limit}`);
}

export async function reprocessMessages(req: ReprocessRequest): Promise<ReprocessResponse> {
  return apiClient.post('/api/dlq/reprocess', req);
}

export async function reprocessAllMessages(req: ReprocessAllRequest): Promise<ReprocessAllResponse> {
  return apiClient.post('/api/dlq/reprocess-all', req);
}

export async function getReprocessJobStatus(jobId: string): Promise<ReprocessJobStatus> {
  return apiClient.get(`/api/dlq/reprocess-job/${jobId}`);
}

export async function deleteMessages(req: DeleteRequest): Promise<DeleteResponse> {
  return apiClient.post('/api/dlq/delete', req);
}

export async function purgeQueue(req: PurgeRequest): Promise<PurgeResponse> {
  return apiClient.post('/api/dlq/purge', req);
}

// ── DLQ Audit API ──

export async function getDlqAuditList(params: DlqAuditListParams = {}): Promise<DlqAuditListResponse> {
  const searchParams = new URLSearchParams();
  if (params.queue) searchParams.set('queue', params.queue);
  if (params.status) searchParams.set('status', params.status);
  if (params.entityType) searchParams.set('entityType', params.entityType);
  if (params.entityId) searchParams.set('entityId', params.entityId);
  if (params.limit) searchParams.set('limit', String(params.limit));
  if (params.cursor) searchParams.set('cursor', params.cursor);

  const queryString = searchParams.toString();
  return apiClient.get(`/api/dlq/audit${queryString ? `?${queryString}` : ''}`);
}

export async function getDlqAuditStats(): Promise<DlqAuditStatsResponse> {
  return apiClient.get('/api/dlq/audit/stats');
}

export async function batchUpdateDlqAudit(req: BatchUpdateDlqAuditRequest): Promise<{ updated: number; failed: number }> {
  return apiClient.post('/api/dlq/audit/batch-update', req);
}

export async function syncDlqMessages(queue: QueueName): Promise<{ synced: number; total: number; iterations: number }> {
  return apiClient.post('/api/dlq/sync', { queue });
}
